import type SearchQueryItem from '@this/src/domain/search_query_item';
import type { TransitJson } from '@this/src/domain/select_repository';
import { Fetcher } from '@this/src/util';
import moment from 'moment';

// API呼び出し関数
export const requestShortDistanceData = async (
  queryItem: SearchQueryItem,
  fromLocation: string,
  toLocation: string,
  departureTime: string,
  timeType: string,
  isOutbound: boolean
): Promise<TransitJson[]> => {
  const originalParams = queryItem.transitParams();
  const fullDateTime = `${isOutbound ? originalParams.outdate : originalParams.homedate} ${departureTime}`;
  const adjustedTime = isOutbound
    ? moment(fullDateTime).subtract(30, 'm').format('YYYY-MM-DD HH:mm')
    : moment(fullDateTime).add(30, 'm').format('YYYY-MM-DD HH:mm');

  const requestParams = {
    org_lat: isOutbound ? originalParams.org_lat : queryItem.orgGeocode?.location.lat,
    org_lng: isOutbound ? originalParams.org_lng : queryItem.orgGeocode?.location.lng,
    dest_lat: !isOutbound ? originalParams.dest_lat : queryItem.destGeocode?.location.lat,
    dest_lng: !isOutbound ? originalParams.dest_lng : queryItem.destGeocode?.location.lng,
    outdate: originalParams.outdate,
    outhour: originalParams.outhour,
    outmin: originalParams.outmin,
    outtype: originalParams.outtype,
    homedate: originalParams.homedate,
    homehour: originalParams.homehour,
    homemin: originalParams.homemin,
    peoplenum: originalParams.peoplenum,
    sd_from: fromLocation,
    sd_to: toLocation,
    sd_time: adjustedTime,
    sd_type: timeType,
    direction: isOutbound ? 'outdate' : 'home'
  };

  return Fetcher.get<TransitJson[]>('transit_shortdistance.json', requestParams);
};
